import { ProblemaCondicaoSelectFieldModel } from 'components/form/field/select/ProblemaCondicaoSelectField/ProblemaCondicaoSelectField'
import createDecorator from 'final-form-calculate'
import { SituacaoProblema } from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'

import { convertProblemaCondicao } from './converter'
import { ProblemaCondicaoModel } from './model'

const meta = metaPath<{ [x: string]: ProblemaCondicaoModel }>()

const findProblema = (problemasCidadao: ProblemaCondicaoSelectFieldModel[], ciapId: ID, cid10Id: ID) =>
  (problemasCidadao || []).find(
    (problema) => problema && ciapId === problema.ciap?.id && cid10Id === problema.cid10?.id && !problema.descricaoOutro
  )

export const createProblemaCondicoesCalculator = (
  problemasCidadao: ProblemaCondicaoSelectFieldModel[],
  dataNascimentoCidadao: LocalDate,
  prefix: string
) =>
  createDecorator(
    {
      field: [meta[prefix].problemaCondicaoEvoluir.absolutePath()],
      updates: (value: ProblemaCondicaoSelectFieldModel) => {
        const problema = findProblema(problemasCidadao, value?.ciap?.id, value?.cid10?.id)

        return {
          [prefix]: { ...convertProblemaCondicao(problema, dataNascimentoCidadao), problemaCondicaoEvoluir: value },
        }
      },
    },
    {
      field: [meta[prefix].situacaoProblema.absolutePath()],
      updates: (value: SituacaoProblema, field: string, allValues: { [x: string]: ProblemaCondicaoModel }) =>
        allValues[prefix]?.situacaoProblema === SituacaoProblema.ATIVO
          ? {
              [prefix]: {
                ...allValues[prefix],
                dataFim: undefined,
              },
            }
          : {
              [prefix]: {
                ...allValues[prefix],
              },
            },
    },
    {
      field: [meta[prefix].incluirNaListaProblemas.absolutePath()],
      updates: (value: boolean, field: string, allValues: { [x: string]: ProblemaCondicaoModel }) => {
        const problemaEncontrado = findProblema(
          problemasCidadao,
          allValues[prefix]?.ciap?.id,
          allValues[prefix]?.cid?.id
        )
        const problema = problemaEncontrado
          ? {
              ...convertProblemaCondicao(problemaEncontrado, dataNascimentoCidadao),
              problemaCondicaoEvoluir: allValues[prefix].problemaCondicaoEvoluir,
            }
          : { ...allValues[prefix] }

        return !allValues[prefix]?.incluirNaListaProblemas
          ? {
              [prefix]: {
                ...allValues[prefix],
                situacaoProblema: undefined,
                dataInicio: undefined,
                dataFim: undefined,
                observacao: undefined,
              },
            }
          : { [prefix]: problema }
      },
    }
  )
